export const mapThemeSchemaFormToDTO = (themeSchemaForm) => ({
    name: themeSchemaForm.data.name,
    schema: {
        background: themeSchemaForm.data.backgroundPrimaryColor,
        secondaryBackground: themeSchemaForm.data.backgroundSecondaryColor,
        fontColor: themeSchemaForm.data.fontColor,
        fontFamily: themeSchemaForm.data.fontFamily,
        imageUrl: themeSchemaForm.data.imageAddress,
        titleColor: themeSchemaForm.data.titleColor,
        navigationColor: themeSchemaForm.data.navigationPrimaryColor,
        navigationSecondaryColor: themeSchemaForm.data.navigationSecondaryColor,
        shadowColor: themeSchemaForm.data.shadowColor,
        shadowZIndex: themeSchemaForm.data.shadowDepth,
        bubbleZIndex: themeSchemaForm.data.stepDepth,
    },
});

export const mapThemeSchemaDTOToForm = (themeSchemaDTO) => ({
    themeId: themeSchemaDTO.id,
    name: themeSchemaDTO.name,
    schema: {
        backgroundPrimaryColor: themeSchemaDTO.schema.background,
        backgroundSecondaryColor: themeSchemaDTO.schema.secondaryBackground,
        fontColor: themeSchemaDTO.schema.fontColor,
        fontFamily: themeSchemaDTO.schema.fontFamily,
        imageAddress: themeSchemaDTO.schema.imageUrl,
        titleColor: themeSchemaDTO.schema.titleColor,
        navigationPrimaryColor: themeSchemaDTO.schema.navigationColor,
        navigationSecondaryColor: themeSchemaDTO.schema.navigationSecondaryColor,
        shadowColor: themeSchemaDTO.schema.shadowColor,
        shadowDepth: themeSchemaDTO.schema.shadowZIndex,
        stepDepth: themeSchemaDTO.schema.bubbleZIndex,
    },
});
